<script setup lang="ts">
import ClaimCertificateSVG from '@/assets/images/illustrations/claim-certificate.svg';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

const props = defineProps<{
  state: 'basic' | 'pro' | 'pro-claimed';
}>();

const emit = defineEmits<{
  (e: 'claimCertificate', callback: () => void): void;
}>();

const loading = ref<string | boolean>(false);

const claimCertificate = async () => {
  loading.value = "Working on certificate ...";

  emit('claimCertificate', () => {
    loading.value = false;
  });
};

</script>

<template>
  <Card
    class="rounded-2xl shadow-medmastery mt-14"
    :pt="{
      content: {
        class: 'p-0'
      }
    }"
  >
    <template #content>
      <div class="flex justify-center -mt-16">
        <ClaimCertificateSVG />
      </div>

      <div class="text-center text-24 text-neutral-90 font-bold mt-4">
        You are awesome!
      </div>

      <div class="text-center text-18 mt-2">
        You completed all the quizzes for this course.
      </div>

      <div
        v-if="props.state === 'basic'"
        class="text-center mt-4 text-neutral-40 italic text-12"
      >
        * This certificate does not include CME credits.
      </div>

      <Button
        :disabled="!!loading"
        class="font-bold !text-22 text-nowrap flex gap-4 px-12 bg-blue-30 text-neutral-90 border-none rounded-lg w-full justify-center mt-6"
        :loading="!!loading"
        @click="claimCertificate"
      >
        <span v-if="state === 'basic' || state === 'pro-claimed'">Download certificate</span>
        <span v-else>Claim certificate</span>

        <FontAwesomeIcon
          v-if="!!loading"
          icon="fa-circle-notch"
          class="animate-spin"
        />
        <FontAwesomeIcon
          v-else
          icon="fa-down-to-bracket"
        />
      </Button>
    </template>
  </Card>
</template>
